import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6d379eff&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6d379eff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d379eff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d379eff')) {
      api.createRecord('6d379eff', component.options)
    } else {
      api.reload('6d379eff', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6d379eff&scoped=true&", function () {
      api.rerender('6d379eff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X2jv0xHzqH3C/JS/comp/GuestBox.vue"
export default component.exports